/*!
 * @Author: leo
 * @Date: 2019-12-27 18:12:00
 * @Last Modified by: leo
 * @Last Modified time: 2019-12-27 18:12:00
 * @Introduction: Cookies 模块
 */

import Cookies from 'js-cookie'
const expires = 7
const PREFIX = 'pd_'

// App
const sidebarStatusKey = PREFIX + 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

const languageKey = PREFIX + 'language'
export const getLanguage = () => Cookies.get(languageKey)
export const setLanguage = (language: string) => Cookies.set(languageKey, language, {
    expires: expires
})

// User
const tokenKey = PREFIX + 'token'
export const getToken = () => Cookies.get(tokenKey)
export const setToken = (token: string) => Cookies.set(tokenKey, token, {
    expires: expires
})
export const removeToken = () => Cookies.remove(tokenKey)

const userIdKey = PREFIX + 'user_id'
export const getUserId = () => Cookies.get(userIdKey)
export const setUserId = (userId: string) => Cookies.set(userIdKey, userId, {
    expires: expires
})
export const removeUserId = () => Cookies.remove(userIdKey)
